import React from 'react'
import { Box, Tooltip } from '@chakra-ui/react'
import { FaPencilAlt } from 'react-icons/fa'

interface iProps {
  value: boolean
  OnChange: (value: boolean) => void
  isDisabled?: boolean
}

export const ToggleButtonCmp: React.FC<iProps> = ({ value, OnChange, isDisabled }) => {
  return (
    <Tooltip label={value ? 'Sair do modo edição' : 'Entrar em modo edição'} hasArrow>
      <Box
        as="button"
        type="button"
        disabled={isDisabled}
        onClick={() => OnChange(!value)}
        position="relative"
        h="36px"
        w="36px"
        p="0"
        top="-4px"
        borderRadius="50%"
        display="grid"
        placeItems="center"
        cursor={isDisabled ? 'not-allowed' : 'pointer'}
        outline="none"
        bg="none"
        boxShadow="0px 1px 6px rgba(0, 0, 0, 0)"
        _hover={{ boxShadow: value ? 'none' : '0px 2px 8px rgba(0, 0, 0, 0.25)', bg: '#FFFFFF' }}
        _focus={{ outline: 'none' }}
        _focusVisible={{ outline: 'none' }}
        transitionDuration="600ms"
      >
        <Box
          position="absolute"
          inset="0"
          borderRadius="50%"
          bg="#FFFFFF"
          opacity={value ? 1 : 0}
          transition="opacity 600ms ease-in-out"
          boxShadow="inset 0px 2px 16px rgba(0, 0, 0, 0.25)"
          pointerEvents="none"
        />

        <Box
          position="relative"
          zIndex={1}
          color={'#1961E0'}
          transition="color 600ms ease-in-out"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <FaPencilAlt size={16} />
        </Box>
      </Box>
    </Tooltip>
  )
}
